import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'
import './index.scss'
import './cstm.scss'

const TemplateWrapper = ({ children }) => (
  <div id="outer-container">
    <Helmet
      title="Nisadhya Digital Marketing Pvt Ltd | Kathmandu Nepal"
      meta={[
        { name: 'description', content: 'Gatsby Skeleton' },
        { name: 'keywords', content: 'sample, something' },
      ]}
    />
    <Header />
    <main id="page-wrap">
      <section>
        {children()}
      </section>
      <Footer />
    </main>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js